import React from 'react';
import styles from './SportTitle.module.scss';
import LiveBadge from '../../../shared/LiveBadge/LiveBadge';
import Sport from '../../../shared/SportIcons/Sport';

const SportTitle = ({ title, isLive, sportId }) => {
    return (
        <div className={styles.sportTitle}>
            <Sport sportId={sportId} isActive className={'m-r-3'} />
            <span className={styles.sportName}>{title}</span>
            <LiveBadge isLive={isLive} />
        </div>
    );
};

export default SportTitle;
